import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Every pillar opens with the same eyebrow / headline / lead block. Sharing one
 * wrapper does two things a copy-pasted div cannot: it gives each section a
 * short rule that anchors the eyebrow instead of leaving it floating, and it
 * reveals the block once on entry so the page arrives in beats rather than all
 * at once. Motion is skipped entirely when the user asks for reduced motion.
 */
export function SectionIntro({
  children,
  className = '',
  align = 'center'
}: {
  children: React.ReactNode;
  className?: string;
  align?: 'center' | 'left';
}) {
  const reduce = useReducedMotion();
  return <motion.div initial={reduce ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.35
  }} transition={{
    duration: 0.6,
    ease: [0.23, 1, 0.32, 1]
  }} className={className} data-id="element-652" data-mp="167d382w45edr">
      <span aria-hidden="true" className={`mb-6 block h-[3px] w-9 rounded-full bg-[#EA580C] ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-653" data-mp="w8nwn69o3gct" />
      {children}
    </motion.div>;
}